import { PlessUploadServiceSub } from '../../../../commons/kymw00/pless-upload-sub.service';
import { KYMW1704Model } from '../kymw1704.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessJsonUploadServiceSub } from 'src/app/commons/kymw00/pless-json-upload-sub.service';


/**
 * 画面再表示時の情報取得するサービス
 *
 * @export ReplaceImageFileUploadService
 * @class ReplaceImageFileUploadService
 * @extends {PlessUploadServiceSub}
 */
@Injectable()
export class ReplaceImageFileUploadService extends PlessJsonUploadServiceSub<any> {

  private vo: any;

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1704Model}
   * @memberof ReplaceImageFileUploadService
   */
  private model: KYMW1704Model;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof ReplaceImageFileUploadService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof ReplaceImageFileUploadService
   */
  private getBody(): PlessRequest {
    return new PlessRequest();
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param {Function} successFunc 成功時後続処理
   * @memberof ReplaceImageFileUploadService
   */
  execute(model: any, vo: any, successFunc: Function): void {
    this.model = <KYMW1704Model> model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.sendFile('KYMW17ReplaceImageFileUpload', this.getBody(), vo.fileRef);
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof ReplaceImageFileUploadService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
